import React from "react";

import {LeadModel} from "@/typings/models/Lead";
import PrettyDate from "@/components/PrettyDate";

import styles from "./index.less"
import {F} from "@/utils/intl";

const LeadCreatedAt = ({lead, isTable, isCustomer = false}: {lead: LeadModel, isTable?: boolean,isCustomer?:boolean}) => {
  const content = (
    <PrettyDate absolute date={isCustomer ? lead?.customer?.created : lead.created} />
  );

  if (isTable) return content

  return <div>
    <div className={styles.tinyDateKey}><F id={"pages.lead.fields.createdAt"} defaultMessage={"Created at"}/></div>
    <div><PrettyDate absolute date={lead.created}/></div>
  </div>

}

export default LeadCreatedAt
